module.exports = __webpack_public_path__ + "static/media/mission.9d794f4a.webp";